import Navbar from "./Navbar";
import Reference from "./reference";
function ReferenceUI(){
    return(
        <>
        <Navbar/>
        <Reference/>
        </>
    )
}
export default ReferenceUI;